import Header from "../Header";
import Footer from "../Footer";
import LoadingSpinner from "./LoadingSpinner";

const LoadingState = ({
  message,
  size = "md",
  variant = "default",
  fullPage = false,
  withHeader = false,
  withFooter = false,
  branded = false,
  brandedCompact = false,
  className = "",
}) => {
  const useBranded = branded || fullPage;
  const logoRing = brandedCompact ? "h-14 w-14 border-2" : "h-20 w-20 border-[3px]";
  const logoImg = brandedCompact ? "h-10 w-10" : "h-14 w-14";
  const brandedMb = brandedCompact ? "mb-2" : "mb-5";

  const content = (
    <div className={`flex flex-col items-center justify-center text-center ${className || "py-12"}`}>
      {useBranded ? (
        <div className={`relative flex items-center justify-center ${brandedMb}`}>
          <div
            className={`absolute rounded-full border-primary-fixed-dim border-t-primary animate-spin ${logoRing}`}
            aria-hidden="true"
          />
          <img src="/logo.png" alt="Elthium Health" className={`relative object-contain ${logoImg}`} />
        </div>
      ) : (
        <LoadingSpinner size={size} variant={variant} />
      )}
      {message && (
        <p
          className={`text-on-surface-variant ${
            useBranded ? (brandedCompact ? "mt-1 text-xs" : "mt-2 text-base") : "mt-4 text-sm sm:text-base"
          }`}
        >
          {message}
        </p>
      )}
    </div>
  );

  if (fullPage) {
    return (
      <div className="min-h-screen bg-background flex flex-col">
        {withHeader && <Header />}
        <div className={`flex-1 flex items-center justify-center ${withHeader ? "pt-16" : ""}`}>
          {content}
        </div>
        {withFooter && <Footer />}
      </div>
    );
  }

  return content;
};

export default LoadingState;
